var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephonie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telephonie"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.78,46.18l-5.57-5.34a3.7,3.7,0,0,0-4.77-.32h0l0,0a.13.13,0,0,1-.08,0,.11.11,0,0,1,0,0A18.86,18.86,0,0,1,24.79,26.7a.09.09,0,0,1,0-.05h.11a3.68,3.68,0,0,0,4.37-2L33,17.14A2.77,2.77,0,0,0,32.4,14a7,7,0,0,0-1-.84,7.58,7.58,0,0,0-10.33,1.59c-.16.2-.3.41-.44.62h0a19.14,19.14,0,0,0-1.11,1.88l-.08.15a30.55,30.55,0,0,0-2.7,6.79,31.31,31.31,0,0,0,.2,12.69,27,27,0,0,0,5.6,11.35.84.84,0,0,0,1.28-1.08,25.11,25.11,0,0,1-5.25-10.64,29.58,29.58,0,0,1-.19-12,28.57,28.57,0,0,1,2.54-6.31L21,18c.32-.6.66-1.18,1-1.75h0a6,6,0,0,1,.36-.52,5.91,5.91,0,0,1,8.05-1.23,5.6,5.6,0,0,1,.78.65h0a1.08,1.08,0,0,1,.21,1.25L27.8,24a2,2,0,0,1-2.4,1.09h0a1.76,1.76,0,0,0-1.4.18,1.7,1.7,0,0,0-.81,1.14,20.42,20.42,0,0,0,2.71,15.06,1.76,1.76,0,0,0,1.16.79,1.78,1.78,0,0,0,1.39-.33l0,0a2,2,0,0,1,2.62.19l5.56,5.34a2.11,2.11,0,0,1,.25,2.53A5.69,5.69,0,0,1,33,52.45a5.87,5.87,0,0,1-4.36-1,.84.84,0,0,0-1,1.37A7.6,7.6,0,0,0,32,54.21a7.9,7.9,0,0,0,1.28-.11,7.39,7.39,0,0,0,5.08-3.34l0,0A3.79,3.79,0,0,0,37.78,46.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.81,19.37a9,9,0,0,0-9,9,8.13,8.13,0,0,0,.1,1.3l-1.49,4.84a.84.84,0,0,0,.75,1.08l4.62.25a9,9,0,1,0,5-16.47Zm0,16.32a7.27,7.27,0,0,1-4.25-1.36.86.86,0,0,0-.44-.15L32.33,34l1.23-4a5.82,5.82,0,0,0-.07-1.61,7.32,7.32,0,1,1,7.32,7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.77,27.77a.84.84,0,0,0,0,1.67.84.84,0,1,0,0-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.39,49.32a.84.84,0,1,0,.84.88A.85.85,0,0,0,25.39,49.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.06,27.77a.84.84,0,0,0,0,1.67.84.84,0,1,0,0-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.35,27.77a.84.84,0,1,0,.83.87A.83.83,0,0,0,44.35,27.77Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephonie);
export default __webpack_public_path__ + "static/media/telephonie.454906dbd198cdd0ecdc66bb0134bdc9.svg";
export { ForwardRef as ReactComponent };